import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthorizationService } from '@bo-client/core/authorization/authorization.service';
import { UserPermission } from '@bo-client/shared/models/userPermissions.enum';
import { GenericConfirmationModalComponent } from '@bo-client/shared/modals/generic-confirmation-modal/generic-confirmation-modal.component';
import { MatDialogSize } from '@bo-client/shared/constants/mat-dialog-size';
import { path } from '@bo-client/shared/constants/path';

@Injectable()
export class PermissionGuard {
  private compUnsubs$ = new Subject<void>();

  constructor(
    private router: Router,
    private authorizationService: AuthorizationService,
    private matDialog: MatDialog
  ) {}

  canActivate(next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const permission = next.data['permission'] as UserPermission | undefined;
    if (!permission || this.authorizationService.hasPermission(permission)) {
      return true;
    }

    this.showUnauthorizedMessage();
    return false;
  }

  private showUnauthorizedMessage() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'permission-guard-unauthorized-message';
    dialogConfig.maxHeight = MatDialogSize.maxHeight;
    dialogConfig.width = MatDialogSize.width;
    dialogConfig.data = {
      title: 'Unauthorized Access',
      message: 'Sie haben keine Berechtigung für den Zugriff auf diese Seite',
      confirmText: 'Ok',
      errorMessage: true
    };

    this.matDialog
      .open(GenericConfirmationModalComponent, dialogConfig)
      .afterClosed()
      .pipe(takeUntil(this.compUnsubs$))
      .subscribe(() => {
        this.router.navigate([this.authorizationService.selectPrefixUrl() + '/' + path.home], {
          replaceUrl: true
        });
        this.compUnsubs$.next();
        this.compUnsubs$.complete();
      });
  }
}
